import _ from 'underscore'

const getRegion = ( points, padding = 0.005, proportion ) => {

  const aux = points
    .map( ( [ lat, lon ] ) => ( {
      lat,
      lon
    } ) )

  const maxLat = _.max( aux, 'lat' )
  const minLat = _.min( aux, 'lat' )
  const maxLon = _.max( aux, 'lon' )
  const minLon = _.min( aux, 'lon' )

  return [
    [ minLat.lat - padding, minLon.lon - padding ],
    [ maxLat.lat + padding, maxLon.lon + padding ]
  ]
}

export default getRegion
